import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../';

export const Blurb = ({ text, buttonLabel, dropCap = true, bug, buttonVersion, alt }) => {
  const [readMore, setReadMore] = useState(false);
  const isArrow = buttonVersion === 'arrow';
  const dropCapClassName = alt ? 'drop-cap-alt' : 'drop-cap';
  let textCopy = text;
  let newTextSliced = text; //set to original text passed in
  const slicedText = textCopy.replace(
    /(<([^>]+)>)/gi,
    ''
  );  

  if (text && slicedText.length > 1028) {
    const difference = text.length - slicedText.length;
    newTextSliced = textCopy.slice(
      0,
      1028 + difference
    );
  }


  return (
    <div className="blurb__container">
      <div className="blurb__container__inner">
        {bug && (
          <div className="blurb__container__bug">
            <img src={bug} alt="bug" />
          </div>
        )}
        {!readMore && <div
          className={`blurb__container__copy blurb__container__copy--${dropCap ? dropCapClassName : 'standard'}`}
          dangerouslySetInnerHTML={{__html: newTextSliced}}
        />}
        {text && (
          <a
            className={isArrow ? '' : ''}
            onClick={() => {
              setReadMore(true)
            }}
          >
          {!readMore &&
            <Button
              version={buttonVersion || 'rounded'}
              label={buttonLabel || 'Read More +'}
              labelColor={isArrow ? '#ED5C30' : "#ED5C30"}
              labelHoverColor={isArrow ? '#000' : '#000'}
              hoverColor={isArrow ? 'transparent' : 'transparent'}
              bgColor={isArrow ? '#ED5C30' : "#ED5C30"}
            />}
          </a>
        )}
        {readMore && <div
          className={`blurb__container__copy blurb__container__copy--${dropCap ? dropCapClassName : 'standard'}`}
          dangerouslySetInnerHTML={{__html: text}}
        />}
        {text && (
          <a
            className={isArrow ? '' : ''}
            onClick={() => {
              setReadMore(false)
            }}
          >
          {readMore &&
            <Button
              version={buttonVersion || 'rounded'}
              label={buttonLabel || 'Read Less -'}
              labelColor={isArrow ? '#ED5C30' : "#ED5C30"}
              labelHoverColor={isArrow ? '#000' : '#000'}
              hoverColor={isArrow ? 'transparent' : 'transparent'}
              bgColor={isArrow ? '#ED5C30' : "#ED5C30"}
            />}
          </a>
        )}
      </div>
    </div>
  );
};

Blurb.propTypes = {
  text: PropTypes.string,
  buttonLabel: PropTypes.string
}
